/*
 * @Author: Shirtiny
 * @Date: 2021-06-08 17:06:56
 * @LastEditTime: 2021-08-16 18:02:39
 * @Description:
 */
import logger from "@shirtiny/logger";

let consoleLog = localStorage.getItem("consoleLog") || "on";

console.warn = function () {
  return;
};

export function setConsoleLog(islog) {
  logger.setEnable(islog);
  consoleLog = islog ? "on" : "off";
  localStorage.setItem("consoleLog", consoleLog);
}

export function getConsoleLogBoolean() {
  return consoleLog === "on";
}

export function log(...message) {
  return logger.log(...message);
}

export function error(...message) {
  return logger.error(new Error(message.join("")), ...message);
}

export function httpLog(...message) {
  return logger.http(...message);
}

export function dataLog(...message) {
  return logger.service(...message);
}

export default {
  log,
  error,
  dataLog,
  httpLog,
  setConsoleLog,
  getConsoleLogBoolean,
};
